import { render, staticRenderFns } from "./createUser_page.vue?vue&type=template&id=49b1f857&scoped=true&"
import script from "./createUser_page.vue?vue&type=script&lang=js&"
export * from "./createUser_page.vue?vue&type=script&lang=js&"
import style0 from "./createUser_page.vue?vue&type=style&index=0&id=49b1f857&prod&scoped=true&lang=css&"
import style1 from "./createUser_page.vue?vue&type=style&index=1&id=49b1f857&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1f857",
  null
  
)

export default component.exports